const BASE_URL = 'https://challengeurselfmasterbackend-production.up.railway.app/api/challenge';

let onUnauthorized = () => {};

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('auth_token') ?? ''}`
});

async function apiFetch(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: { ...authHeaders(), ...options.headers },
  });

  if (res.status === 401) {
    onUnauthorized();
    throw new Error('SESSION_EXPIRED');
  }

  if (!res.ok) {
    throw new Error(`HTTP_${res.status}`);
  }

  return res;
}

const serverApi = {
  getChallenges: async () => {
    const res = await apiFetch(BASE_URL);
    return res.json();
  },
  createChallenge: async (challenge) => {
    const res = await apiFetch(BASE_URL, {
      method: 'POST',
      body: JSON.stringify(challenge)
    });
    return res.json();
  },
  updateChallenge: async (id, challenge) => {
    const res = await apiFetch(`${BASE_URL}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(challenge)
    });
    return res.json();
  },
  deleteChallenge: async (id) => {
    await apiFetch(`${BASE_URL}/${id}`, { method: 'DELETE' });
    return true;
  }
};

export const getChallenges = serverApi.getChallenges;
export const createChallenge = serverApi.createChallenge;
export const updateChallenge = serverApi.updateChallenge;
export const deleteChallenge = serverApi.deleteChallenge;
